import { Model, Attr, HasOne } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import { Lot } from './';

@Model()
export default class Quote extends ApplicationRecord {
  static jsonapiType = 'quotes';

  static scopeFactory() {
    return Quote.includes([]);
  }

  @Attr() price: string;
  @Attr() startDate: string;
  @Attr() endDate: string;
  @Attr() fillThresholdExceeded: boolean;

  @HasOne() lot: Lot;

  get formattedPrice() {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
    })
      .format(Number(this.price))
      .replace(/\.00/g, '');
  }
}
